import { createStore } from 'vuex'
import authn from "./auth.js";

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    authn,
  }
})
